import "./stats.css"
import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Chart from "react-apexcharts"
import { FaGamepad, FaCalendarAlt } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

const d = new Date();


class AdminStatGames extends Component {
    constructor(props) {
        super(props)
        this.state = {
            games_by_day: {},
            games_by_hour: {},
            games_by_month: {},
            games_real_players_by_day: {},
            games_by_player: 0,
            games_player_by_day: 0,
            average_games_by_day: 0,
            end_date: new Date().toISOString().substring(0, 10),
            start_date: new Date(d.setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10),
            series_star: null,
        }
    }

    componentDidMount = async () => {
        await this.loadStats()
    }

    loadStats = async () => {
        const games = await AdminService.getGamesStats(this.state.start_date, this.state.end_date)
        let nb_months = [], nb_days = [], nb_hours = [], nb_real_players_days = []
        Object.keys(games.games_by_month).map(key => nb_months.push(games.games_by_month[key]))
        Object.keys(games.games_by_day).map(key => nb_days.push(games.games_by_day[key]))
        Object.keys(games.games_by_hour).map(key => nb_hours.push(games.games_by_hour[key]))
        Object.keys(games.games_real_players_by_day).map(key => nb_real_players_days.push(games.games_real_players_by_day[key]))
        this.setState({
            options_days: { chart: { id: "games-day" }, xaxis: { categories: Object.keys(games.games_by_day) } },
            options_months: { chart: { id: "games-month" }, xaxis: { categories: Object.keys(games.games_by_month) } },
            options_hours: { chart: { id: "games-hour" }, xaxis: { categories: Object.keys(games.games_by_hour) } },
            options_real_players: { chart: { id: "games-real-players" }, xaxis: { categories: Object.keys(games.games_real_players_by_day) } },
            nb_months: [{ name: "games", data: nb_months }],
            nb_days: [{ name: "games", data: nb_days }],
            nb_hours: [{ name: "games", data: nb_hours }],
            nb_real_players_days: [{ name: "games", data: nb_real_players_days }],
            games_by_player: games.games_by_player,
            games_player_by_day: games.games_player_by_day,
            average_games_by_day: games.average_games_by_day,
        })
    }

    render() {
        return (
            <AdminLayout 
                title="Game Statistics"
                breadcrumbs={[
                    { label: 'Statistics', href: '/admin/stats' },
                    { label: 'Games' }
                ]}
            >
                <div className="space-y-6">
                    {/* Header with Date Range */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                        <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                            <FaGamepad className="text-red-600" />
                            Game Statistics
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                    <FaCalendarAlt className="text-gray-500" />
                                    Start Date
                                </label>
                                <input 
                                    type="date" 
                                    defaultValue={this.state.start_date} 
                                    onChange={(e) => this.setState({ start_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                    <FaCalendarAlt className="text-gray-500" />
                                    End Date
                                </label>
                                <input 
                                    type="date" 
                                    defaultValue={this.state.end_date} 
                                    onChange={(e) => this.setState({ end_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Stats Table */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                        <div className="bg-gradient-to-r from-red-50 to-orange-50 px-6 py-3 border-b border-gray-200">
                            <h4 className="font-semibold text-gray-900">Game Statistics Overview</h4>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Av. Games per player</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Av. Games per player per day</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Av. Games per day</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b border-gray-200">
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-red-600">{this.state.games_by_player}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-red-600">{this.state.games_player_by_day}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-red-600">{this.state.average_games_by_day}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Charts */}
                    <div className="grid grid-cols-1 gap-6">
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Games per Month</h4>
                            {this.state.nb_months && <Chart options={this.state.options_months} series={this.state.nb_months} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Games per Day</h4>
                            {this.state.nb_days && <Chart options={this.state.options_days} series={this.state.nb_days} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Games per Hour</h4>
                            {this.state.nb_hours && <Chart options={this.state.options_hours} series={this.state.nb_hours} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Games per Day Between Players</h4>
                            {this.state.nb_real_players_days && <Chart options={this.state.options_real_players} series={this.state.nb_real_players_days} type="bar" />}
                        </div>
                    </div>
                </div>
            </AdminLayout>
        )
    }
}

export default withTranslation()(AdminStatGames)